import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SkillModel } from '../../models/skill.model';
import { SKILL_NAME_SV_TO_EN } from '../constants/skill-name-en.map';

@Pipe({
    name: 'skillDisplayName',
    standalone: true,
})
export class SkillDisplayNamePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(skill: SkillModel | { id: number; name: string } | null | undefined): string {
        if (!skill?.name) {
            return '';
        }
        const lang = this.translate.currentLang || this.translate.defaultLang || 'sv';
        if (lang === 'en' || lang.startsWith('en')) {
            const idKey = `skills.displayNames.${skill.id}`;
            const byId = this.translate.instant(idKey);
            if (byId !== idKey) {
                return byId;
            }
            const normalized = skill.name.trim().toLowerCase();
            return SKILL_NAME_SV_TO_EN[normalized] ?? skill.name;
        }
        return skill.name;
    }
}
